import { appRouterPaths } from "@/services/navigation";
import { PasswordRecovery } from "@/pages/RegistrationPage/Components/PasswordRecovery";
import type { RouteProps } from "react-router-dom";

export const passwordRecoveryPageRoute: RouteProps = {
  path: appRouterPaths.passwordRecovery,
  element: <PasswordRecovery />,
};
